<template>
  <router-view />
</template>

<style>
#app {
  height: 100%;
}

html,
body {
  margin: 0;
  padding: 0;
  min-height: 100%;
}

body {
  background: #f5f8fb;
}
</style>
